import React from "react";
import { Button } from "@mantine/core";
import { useSelector } from "react-redux";

const ButtonComp = ({
  type,
  text,
  icon,
  onClick,
  btnClass,
  loading,
  size,
  c,
  radius,
  color,
  variant = "filled",
  disabled = false,
  outcomeNumbers,
  isCreateNoteloading,
}) => {
  const { addNoteLoading } = useSelector((state) => state?.note);
  return (
    <>
      <Button
        type={type}
        className={btnClass}
        onClick={onClick}
        loading={loading || isCreateNoteloading ? addNoteLoading : null}
        size={size}
        c={c}
        radius={radius}
        color={color}
        variant={variant}
        disabled={disabled || outcomeNumbers}
      >
        {icon} {`${text ? text : ""}`}
      </Button>
    </>
  );
};

export default ButtonComp;
